export const COPY = {
  session: {
    returned: 'WELCOME BACK. THE ARCHIVE NOTED YOUR RETURN.',
    expired: 'SESSION EXPIRED. SIGNATURE NOT IN FILE.',
  },
  errors: {
    guest: 'GUEST LINK REJECTED. TERMINAL OFFLINE.',
  },
  core: {
    offline: 'LINE DOWN. TERMINAL TALKING TO ITSELF.',
  },
  trade: {
    buy: 'LOT SECURED. COAT WEIGHT UP.',
    sell: 'LOT RELEASED. SPREAD POSTED.',
  },
  travel: {
    arrived: 'DISTRICT INDEXED. ARRIVAL LOGGED.',
  },
  loan: {
    opened: 'NOTE SIGNED. METER RUNNING.',
    repaid: 'PRINCIPAL DOWN. VINNIE WATCHING.',
  },
  audit: {
    bribed: 'OFFICER PAID. LINE ITEM QUIET.',
  },
  coat: {
    expanded: 'COAT EXPANDED. WEIGHT CAP UP.',
  },
  hronir: {
    acquired: 'OBJECT SECURED. CARRIER LOCKED.',
    archived: 'CAPACITY REDUCED. ARCHIVE OPEN.',
    exposed: 'OBJECT BURNED. MARKET SAW IT.',
    liquidated: 'OBJECT SOLD. ABSENCE FILED.',
  },
  home: {
    online: 'SYSTEM LIVE',
    offline: 'LINE DOWN. LOCAL SHELL.',
  },
  signals: {
    empty: 'NO FEED. CHANNEL CLEAN.',
  },
  comms: {
    typing: 'VINNIE IS TYPING...',
  },
};
